export const AGGRESSIVE_BREEDS_LIST = [
  'Akita',
  'American Bulldog',
  'Australian Shepherd Husky',
  'Bulldog',
  'Chusky',
  'Doberdor',
  'German Shepherd Rottweiler Mix',
  'Huskydoodle',
  'Labsky',
  'Akita Chow',
  'Akita Pit',
  'Rhodesian Ridgeback',
  'Rottweiler',
  'Spanish Mastiff',
  'American Pit Bull Terrier',
  'American Staffordshire Terrier',
  'Shepherd Pit Bull Mix',
  'Belgian Malinois',
  'Bullboxer Pit',
  'Caucasian Shepherd Dog',
  'Chow Chow',
  'Chow Shepherd',
  'Doberman Pinscher',
  'German Shepherd Dog',
  'German Shepherd Pit Bull',
  'German Sheprador',
  'Great Dane',
  'Huskita',
  'Keeshond',
  'Labrabull',
  'Labradane',
  'Mastiff',
  'Siberian Husky',
  'Staffordshire Bull Terrier',
];
